import React from 'react';
import { Spinner } from 'reactstrap';

const LoadingOverlay = ({ loading, message = 'Guardando…' }) => {
  if (!loading) return null;
  return (
    <div style={{
      position: 'absolute',
      inset: 0,
      zIndex: 10,
      background: 'rgba(255,255,255,0.7)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      pointerEvents: 'all',
    }}>
      <Spinner animation="border" color="primary" />
      <span className="mt-2 text-muted">{message}</span>
    </div>
  );
};

export default LoadingOverlay;
